import { makeAutoObservable } from 'mobx'

class SortStore {
  sortKey = null
  sortDirection = 'asc' // 'asc' or 'desc'

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  // Action to set the sorting parameters
  setSort(key) {
    if (this.sortKey === key) {
      // If the same key is clicked, toggle the direction
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc'
    } else {
      // If a new key is clicked, set it and default to ascending
      this.sortKey = key
      this.sortDirection = 'asc'
    }
  }

  // A computed getter that returns a comparison function based on the current state.
  // This function can be passed to Array.prototype.sort()
  get sorter() {
    if (!this.sortKey) {
      return () => 0 // No sort, maintain original order
    }

    const key = this.sortKey
    const direction = this.sortDirection === 'asc' ? 1 : -1

    return (a, b) => {
      const valA = a[key] ?? ''
      const valB = b[key] ?? ''

      if (valA < valB) return -1 * direction
      if (valA > valB) return 1 * direction
      return 0
    }
  }
}

export default SortStore
